import styled from 'styled-components';
import { caseBlurBg } from '../../assets/images';

const StyledContainer = styled.div`
	position: absolute;
	top: 140px;
	left: 60px;
	width: 440px;
	height: 100px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;

	transition:
		height 0.25s ease,
		border 0.25s ease;

	&.case-banner-enter {
		opacity: 0;
	}

	&.case-banner-enter-active,
	&.case-banner-enter-done,
	&.case-banner-exit {
		opacity: 1;
	}

	&.case-banner-exit-active {
		opacity: 0;
	}
`;

const StyledTextContainer = styled.div`
	position: absolute;
	top: 30px;
	left: 30px;
	display: flex;
	flex-direction: column;
	gap: 6px;
	color: #ffffff;
`;

const StyledBlurBg = styled.div`
	position: absolute;
	right: -270px;
	top: 50%;
	transform: translateY(-50%);
	width: 540px;
	height: 540px;
	mask-image: url(${caseBlurBg});
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${caseBlurBg});
	-webkit-mask-size: cover;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
`;

const StyledSvg = styled.svg`
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 160px;
	height: 160px;
	z-index: 2;
`;

const StyledCaseImage = styled.img.attrs({
	width: 100,
	height: 100,
})`
	position: absolute;
	right: 30px;
	top: 0;
	z-index: 3;
	user-select: none;
	pointer-events: none;
`;

export {
	StyledBlurBg,
	StyledCaseImage,
	StyledContainer,
	StyledSvg,
	StyledTextContainer,
};
